"use client"

import { useState } from "react"
import { Helmet } from 'react-helmet-async';
import "./CampaignsPage.css"

import IYQ1 from '../../assets/IYQ1.png'
import IYQ2 from '../../assets/IYQ2.png'
import recap1 from '../../assets/recap1.jpg'
import recap2 from '../../assets/recap5.jpg'
import recap3 from '../../assets/recap2.jpg'
import iyqBanner from '../../assets/iyq_banner.jpg'
import hubsBanner from '../../assets/hubs_banner.jpg'
import cern from '../../assets/cern.jpg'
import partner2 from '../../assets/logo2.png'
import partner7 from '../../assets/logo7.png'
import partner9 from '../../assets/logo9.png'
import partner15 from '../../assets/logo15.png'
import partner19 from '../../assets/logo19.png'
import whitePaperCover from '../../assets/whitepaper_cover.png'
import aqsReportCover from '../../assets/aqsReport_cover.jpg'

const ArrowRightIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2" />
    <polyline points="12,5 19,12 12,19" stroke="currentColor" strokeWidth="2" fill="none" />
  </svg>
)

const CalendarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2"/>
  </svg>
)

const GlobeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 3C12 3 8 7 8 12C8 17 12 21 12 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 3C12 3 16 7 16 12C16 17 12 21 12 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" strokeWidth="2"/>
    <line x1="4.5" y1="7" x2="19.5" y2="7" stroke="currentColor" strokeWidth="2"/>
    <line x1="4.5" y1="17" x2="19.5" y2="17" stroke="currentColor" strokeWidth="2"/>
  </svg>
)

const AtomIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="2" fill="currentColor"/>
    <ellipse cx="12" cy="12" rx="10" ry="4" stroke="currentColor" strokeWidth="2"/>
    <ellipse cx="12" cy="12" rx="10" ry="4" stroke="currentColor" strokeWidth="2" transform="rotate(60 12 12)"/>
    <ellipse cx="12" cy="12" rx="10" ry="4" stroke="currentColor" strokeWidth="2" transform="rotate(120 12 12)"/>
  </svg>
)

const CityIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="10" width="5" height="11" stroke="currentColor" strokeWidth="2"/>
    <rect x="10" y="6" width="4" height="15" stroke="currentColor" strokeWidth="2"/>
    <rect x="16" y="13" width="5" height="8" stroke="currentColor" strokeWidth="2"/>
    <line x1="1" y1="21" x2="23" y2="21" stroke="currentColor" strokeWidth="2"/>
  </svg>
)

const BookIcon = () => (
  <svg width="56" height="56" viewBox="0 0 24 24" fill="none">
    <path d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const DownloadIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="7,10 12,15 17,10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const ExternalLinkIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="15 3 21 3 21 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="10" y1="14" x2="21" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const campaigns = [
  { id: "wqd", label: "World Quantum Day", color: "#60a5fa" },
  { id: "iyq", label: "IYQ 2025", color: "#a78bfa" },
  { id: "hundred", label: "100 Years of Quantum", color: "#fbbf24" },
  { id: "qcity", label: "Quantum City", color: "#34d399" },
]

const wqdActivities = [
  { year: "2022", title: "WQD Launch Celebration", desc: "Joined the inaugural global celebration with Nairobi's first quantum meetup, hosting 40+ participants for talks on quantum basics." },
  { year: "2023", title: "Quantum Outreach Day", desc: "Expanded to university campuses, reaching 150+ students across 3 institutions with live quantum demonstrations and Q&A sessions." },
  { year: "2024", title: "Quantum for Kenya", desc: "Panel discussions on Kenya's quantum future, live coding demos with Qiskit, and an open-mic on quantum careers in Africa." },
  { year: "2025", title: "Centennial Quantum Meetup", desc: "Special April 14 edition marking 100 years of quantum mechanics, featuring keynotes, workshops, and social media outreach." },
]

const iyqActivities = [
  { title: "Quantum Day Meetup", date: "April 2025", color: "#60a5fa" },
  { title: "Quantum 101 Workshop", date: "May 2025", color: "#a78bfa" },
  { title: "The Quantum Code: Algorithms", date: "June 2025", color: "#22d3ee" },
  { title: "Quantum City Campaign", date: "August 2025", color: "#34d399" },
  { title: "Demystifying Quantum Series", date: "September 2025", color: "#f472b6" },
  { title: "Qiskit Fall Fest 2025", date: "October 2025", color: "#fbbf24" },
  { title: "Africa Quantum Summit", date: "December 2025", color: "#60a5fa" },
]

const quantumTimeline = [
  { year: "1900", event: "Planck's Quantum Hypothesis", desc: "Max Planck proposes energy is quantized — the birth of quantum theory." },
  { year: "1913", event: "Bohr's Atomic Model", desc: "Niels Bohr describes electron orbits using quantum rules." },
  { year: "1925", event: "Heisenberg's Matrix Mechanics", desc: "Werner Heisenberg (age 23) develops the first complete quantum framework on Helgoland island." },
  { year: "1926", event: "Schrödinger Equation", desc: "Erwin Schrödinger publishes wave mechanics — a different but equivalent formulation." },
  { year: "1947", event: "Transistor Invented", desc: "Quantum mechanics enables the transistor, launching the digital age." },
  { year: "1960", event: "Laser Invented", desc: "Stimulated emission of quantum light — now everywhere from hospitals to fibre optics." },
  { year: "1994", event: "Shor's Algorithm", desc: "Peter Shor proves quantum computers can factor large numbers exponentially faster." },
  { year: "2019", event: "Quantum Supremacy", desc: "Google's Sycamore processor performs a computation in 200 seconds that would take classical computers 10,000 years." },
  { year: "2025", event: "100 Years of Quantum", desc: "IYQ 2025 marks the centenary — the second quantum revolution is underway." },
]

const cityActivities = [
  { icon: "🔬", title: "Public Quantum Exhibitions", desc: "Interactive quantum science displays brought to Nairobi's public spaces — malls, parks, and transit hubs — making quantum accessible to every Nairobian." },
  { icon: "🏫", title: "School Outreach Programme", desc: "Visiting Nairobi's public secondary schools with hands-on demos, quantum puzzles, and career talks — inspiring the next generation of quantum thinkers." },
  { icon: "🌆", title: "Quantum Nairobi Festival", desc: "A citywide quantum awareness day featuring speakers, art installations, and live experiments — celebrating Nairobi's emergence as Africa's quantum hub." },
  { icon: "📡", title: "Quantum City Prize Bid", desc: "Submitting Nairobi's activities to the World Quantum Day Quantum City Prize, positioning Kenya's capital on the global quantum map." },
]

const partners = [
  { name: "Partner 1", logo: partner9 },
  { name: "Partner 2", logo: partner7 },
  { name: "Partner 3", logo: partner19 },
  { name: "Partner 4", logo: partner15 },
  { name: "Partner 5", logo: partner2 },
]

const CampaignsPage = () => {
  const [activeTab, setActiveTab] = useState("wqd")

  const scrollToSection = (id) => {
    setActiveTab(id)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <div className="camps-page">
      <Helmet>
        <title>Quantum Campaigns | QuantumKE</title>
        <meta name="description" content="Explore QuantumKE's quantum awareness campaigns — World Quantum Day, IYQ 2025, 100 Years of Quantum, and the Quantum City initiative in Nairobi." />
        <link rel="canonical" href="https://quantumke.org/campaigns" />
      </Helmet>

      {/* ── Hero ── */}
      <section className="camps-hero">
        <div className="camps-hero-bg" style={{ backgroundImage: `url(${iyqBanner})` }} />
        <div className="camps-hero-overlay" />
        <div className="camps-hero-particles">
          {Array.from({ length: 24 }).map((_, i) => (
            <span key={i} className="camps-particle" style={{
              left: `${(i * 37 + 11) % 100}%`,
              top: `${(i * 53 + 7) % 100}%`,
              animationDelay: `${(i * 0.4) % 5}s`,
              animationDuration: `${3 + (i % 4)}s`,
              width: `${2 + (i % 3)}px`,
              height: `${2 + (i % 3)}px`,
            }} />
          ))}
        </div>
        <div className="camps-hero-content">
          <h1 className="camps-hero-title">
            Our Quantum
            <span className="camps-hero-gradient"> Campaigns</span>
          </h1>
          <p className="camps-hero-subtitle">
            From Nairobi to the world — celebrating quantum science, marking historic milestones,
            and building Africa's quantum future, one campaign at a time.
          </p>
          <div className="camps-hero-stats">
            <div className="camps-hero-stat">
              <span className="camps-hero-stat-num">4+</span>
              <span className="camps-hero-stat-label">Years Active</span>
            </div>
            <div className="camps-hero-stat-divider" />
            <div className="camps-hero-stat">
              <span className="camps-hero-stat-num">7</span>
              <span className="camps-hero-stat-label">IYQ Activities</span>
            </div>
            <div className="camps-hero-stat-divider" />
            <div className="camps-hero-stat">
              <span className="camps-hero-stat-num">5K+</span>
              <span className="camps-hero-stat-label">Lives Reached</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── Sticky Campaign Nav ── */}
      <nav className="camps-nav">
        <div className="camps-nav-inner">
          {campaigns.map(c => (
            <button
              key={c.id}
              className={`camps-nav-btn ${activeTab === c.id ? 'camps-nav-btn--active' : ''}`}
              style={{ '--accent': c.color }}
              onClick={() => scrollToSection(c.id)}
            >
              {c.label}
            </button>
          ))}
        </div>
      </nav>

      {/* ══════════════════════════════════════════
          CAMPAIGN 1 — WORLD QUANTUM DAY
      ══════════════════════════════════════════ */}
      {activeTab === "wqd" && <section id="wqd" className="camps-section camps-section--wqd">
        <div className="camps-container">

          <div className="camps-section-label" style={{ color: '#60a5fa' }}>
            <CalendarIcon />
            <span>Annual · Every April 14</span>
          </div>

          <div className="camps-two-col">
            {/* Left: text */}
            <div className="camps-col-text">
              <h2 className="camps-section-title">
                World<br />
                <span className="camps-gradient-blue">Quantum Day</span>
              </h2>
              <p className="camps-body-text">
                Every April 14, the global quantum community unites to celebrate the science that
                is reshaping our world. The date is no coincidence — it honours the Planck constant
                <strong> h = 4.14 × 10⁻¹⁵ eV·s</strong>, the fundamental heartbeat of all quantum mechanics.
              </p>
              <p className="camps-body-text">
                Launched in 2021 by scientists from 65+ nations, World Quantum Day has grown to
                <strong> 530 events across 83 countries</strong> (2026). QuantumKE has proudly participated
                every year since the first edition, bringing quantum science to Nairobi's streets,
                campuses, and communities.
              </p>
              <div className="camps-planck-box">
                <div className="camps-planck-label">Why April 14?</div>
                <div className="camps-planck-eq">h = 4.14 × 10<sup>−15</sup> eV·s</div>
                <div className="camps-planck-sub">The Planck constant — the quantum of action</div>
              </div>
              <a
                href="https://worldquantumday.org"
                target="_blank"
                rel="noopener noreferrer"
                className="camps-btn camps-btn--blue"
              >
                Visit World Quantum Day <ArrowRightIcon />
              </a>
            </div>

            {/* Right: bento grid — 2 top, 1 bottom */}
            <div className="camps-col-media">
              <div className="camps-bento">
                <div className="camps-bento-top">
                  <div className="camps-bento-cell">
                    <img src={recap1} alt="World Quantum Day Nairobi 2025" className="camps-bento-img" />
                  </div>
                  <div className="camps-bento-cell">
                    <img src={recap2} alt="World Quantum Day community" className="camps-bento-img" />
                  </div>
                </div>
                <div className="camps-bento-bottom">
                  <img src={recap3} alt="World Quantum Day event" className="camps-bento-img" />
                  <div className="camps-bento-badge">
                    <CalendarIcon />
                    <span>Nairobi · Kenya</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Year cards */}
          <div className="camps-year-grid">
            {wqdActivities.map((item, i) => (
              <div key={i} className="camps-year-card" style={{ animationDelay: `${i * 0.1}s` }}>
                <div className="camps-year-badge">{item.year}</div>
                <h3 className="camps-year-title">{item.title}</h3>
                <p className="camps-year-desc">{item.desc}</p>
              </div>
            ))}
          </div>

          {/* Global stats strip */}
          <div className="camps-stats-strip camps-stats-strip--blue">
            <div className="camps-strip-stat">
              <span className="camps-strip-num">530</span>
              <span className="camps-strip-lbl">Events Globally (2026)</span>
            </div>
            <div className="camps-strip-divider" />
            <div className="camps-strip-stat">
              <span className="camps-strip-num">83</span>
              <span className="camps-strip-lbl">Countries Participating</span>
            </div>
            <div className="camps-strip-divider" />
            <div className="camps-strip-stat">
              <span className="camps-strip-num">2022</span>
              <span className="camps-strip-lbl">QuantumKE First Edition</span>
            </div>
            <div className="camps-strip-divider" />
            <div className="camps-strip-stat">
              <span className="camps-strip-num">65+</span>
              <span className="camps-strip-lbl">Founding Nations</span>
            </div>
          </div>
        </div>
      </section>}

      {/* ══════════════════════════════════════════
          CAMPAIGN 2 — IYQ 2025
      ══════════════════════════════════════════ */}
      {activeTab === "iyq" && <section id="iyq" className="camps-section camps-section--iyq">
        <div className="camps-container">

          <div className="camps-section-label" style={{ color: '#a78bfa' }}>
            <GlobeIcon />
            <span>UN Initiative · Full Year 2025</span>
          </div>

          <div className="camps-two-col camps-two-col--reverse">
            {/* Left: YouTube video embed */}
            <div className="camps-col-media">
              <div className="camps-video-wrap">
                <div className="camps-video-embed">
                  <iframe
                    width="100%"
                    height="100%"
                    src="https://www.youtube.com/embed/HOSOuxIYrNY"
                    title="IYQ 2025 - What is Quantum?"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                <div className="camps-iyq-tag">IYQ 2025 · UNESCO</div>
              </div>
            </div>

            {/* Right: text */}
            <div className="camps-col-text">
              <h2 className="camps-section-title">
                International Year<br />
                <span className="camps-gradient-purple">of Quantum 2025</span>
              </h2>
              <p className="camps-body-text">
                The United Nations declared 2025 the International Year of Quantum Science
                and Technology — co-sponsored by <strong>70+ countries representing 5 billion people</strong>.
                Organised by UNESCO and the American Physical Society, IYQ marked 100 years since
                Heisenberg's breakthrough and launched the second quantum revolution.
              </p>
              <p className="camps-body-text">
                QuantumKE was at the forefront of Africa's IYQ participation — hosting 7 landmark
                activities throughout 2025, from beginner workshops to the historic Africa Quantum
                Summit in Nairobi.
              </p>

              <div className="camps-iyq-activities">
                {iyqActivities.map((act, i) => (
                  <div key={i} className="camps-iyq-activity" style={{ borderLeftColor: act.color }}>
                    <span className="camps-iyq-act-date" style={{ color: act.color }}>{act.date}</span>
                    <span className="camps-iyq-act-title">{act.title}</span>
                  </div>
                ))}
              </div>

            </div>
          </div>

          {/* IYQ stats strip */}
          <div className="camps-stats-strip camps-stats-strip--purple">
            <div className="camps-strip-stat">
              <span className="camps-strip-num">70+</span>
              <span className="camps-strip-lbl">Co-Sponsoring Nations</span>
            </div>
            <div className="camps-strip-divider" />
            <div className="camps-strip-stat">
              <span className="camps-strip-num">1M+</span>
              <span className="camps-strip-lbl">People Reached Globally</span>
            </div>
            <div className="camps-strip-divider" />
            <div className="camps-strip-stat">
              <span className="camps-strip-num">7</span>
              <span className="camps-strip-lbl">QuantumKE Activities</span>
            </div>
            <div className="camps-strip-divider" />
            <div className="camps-strip-stat">
              <span className="camps-strip-num">1,000+</span>
              <span className="camps-strip-lbl">Grassroots Events Worldwide</span>
            </div>
          </div>
        </div>
      </section>}

      {/* ══════════════════════════════════════════
          CAMPAIGN 3 — 100 YEARS OF QUANTUM
      ══════════════════════════════════════════ */}
      {activeTab === "hundred" && <section id="hundred" className="camps-section camps-section--hundred">
        <div className="camps-container">

          <div className="camps-section-label" style={{ color: '#fbbf24' }}>
            <AtomIcon />
            <span>Centennial · 1925 – 2025</span>
          </div>

          <div className="camps-hundred-header">
            <h2 className="camps-section-title">
              100 Years of
              <span className="camps-gradient-gold"> Quantum Science</span>
            </h2>
            <p className="camps-body-text camps-body-text--centered">
              In the summer of 1925, a 23-year-old Werner Heisenberg retreated to the North Sea island
              of Helgoland, escaping hay fever. What he discovered there changed everything.
              His matrix mechanics became the first complete mathematical theory of quantum mechanics —
              and 2025 marked exactly one century of that revolution.
            </p>
          </div>

          {/* Helgoland callout */}
          <div className="camps-helgoland-card">
            <div className="camps-helgoland-img-wrap">
              <img src={cern} alt="Quantum research" className="camps-helgoland-img" />
              <div className="camps-helgoland-img-overlay" />
            </div>
            <div className="camps-helgoland-text">
              <div className="camps-helgoland-quote-mark">"</div>
              <blockquote className="camps-helgoland-quote">
                It was about three o'clock at night when the final result of the
                calculation lay before me. I was deeply shaken. I was so excited
                that I could not think of sleep.
              </blockquote>
              <cite className="camps-helgoland-cite">— Werner Heisenberg, Helgoland, June 1925</cite>
              <div className="camps-helgoland-tags">
                <span className="camps-tag camps-tag--gold">Matrix Mechanics</span>
                <span className="camps-tag camps-tag--gold">Helgoland, 1925</span>
                <span className="camps-tag camps-tag--gold">The Quantum Leap</span>
              </div>
            </div>
          </div>

          {/* Timeline */}
          <div className="camps-timeline-header">
            <h3 className="camps-timeline-title">A Century of Quantum Milestones</h3>
          </div>
          <div className="camps-timeline">
            {quantumTimeline.map((item, i) => (
              <div key={i} className={`camps-timeline-item ${i % 2 === 0 ? 'camps-timeline-item--left' : 'camps-timeline-item--right'}`}>
                <div className="camps-timeline-year">{item.year}</div>
                <div className="camps-timeline-dot" />
                <div className="camps-timeline-card">
                  <h4 className="camps-timeline-event">{item.event}</h4>
                  <p className="camps-timeline-desc">{item.desc}</p>
                </div>
              </div>
            ))}
            <div className="camps-timeline-line" />
          </div>

          {/* What QuantumKE did */}
          <div className="camps-hundred-qke">
            <h3 className="camps-hundred-sub">How QuantumKE Celebrated</h3>
            <div className="camps-hundred-activities">
              {[
                { icon: "🎙️", title: "Public Centennial Talks", desc: "Open lectures on 100 years of quantum breakthroughs, accessible to everyone — no physics background required." },
                { icon: "📖", title: "Quantum History Exhibition", desc: "A visual timeline from Planck's 1900 hypothesis to today's quantum computers, displayed in Nairobi's public spaces." },
                { icon: "🌍", title: "Swahili Quantum Content", desc: "Produced quantum history explainers in Swahili, making the centenary accessible to Kenya's broader community." },
                { icon: "🔭", title: "Next 100 Years Panel", desc: "A forward-looking discussion on what quantum computing means for Kenya and Africa in the century ahead." },
              ].map((act, i) => (
                <div key={i} className="camps-hundred-activity">
                  <div className="camps-hundred-act-icon">{act.icon}</div>
                  <h4 className="camps-hundred-act-title">{act.title}</h4>
                  <p className="camps-hundred-act-desc">{act.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>}

      {/* ══════════════════════════════════════════
          CAMPAIGN 4 — QUANTUM CITY
      ══════════════════════════════════════════ */}
      {activeTab === "qcity" && <section id="qcity" className="camps-section camps-section--qcity">
        <div className="camps-container">

          <div className="camps-section-label" style={{ color: '#34d399' }}>
            <CityIcon />
            <span>Quantum City Campaign · August 2025</span>
          </div>

          <div className="camps-two-col">
            {/* Left: text */}
            <div className="camps-col-text">
              <h2 className="camps-section-title">
                Nairobi:<br />
                <span className="camps-gradient-teal">Quantum City</span>
              </h2>
              <p className="camps-body-text">
                The Quantum City Prize, launched by World Quantum Day in 2025, recognises cities
                that bring quantum science out of university labs and into <strong>public urban spaces</strong> —
                making quantum something every citizen encounters, not just scientists.
              </p>
              <p className="camps-body-text">
                QuantumKE led Nairobi's Quantum City Campaign in August 2025, bringing quantum
                awareness to the city's streets, schools, and public spaces — positioning Nairobi
                as East Africa's quantum capital and competing on the global stage.
              </p>
              <p className="camps-body-text">
                Nairobi hosted the <strong>Africa Quantum Summit (October & December 2025)</strong> at
                Strathmore University — the most prominent quantum science event on the continent,
                cementing Kenya's status as Africa's quantum hub.
              </p>
              <div className="camps-qcity-tags">
                <span className="camps-tag camps-tag--teal">🌍 Africa's Quantum Hub</span>
                <span className="camps-tag camps-tag--teal">🏆 Quantum City Prize</span>
                <span className="camps-tag camps-tag--teal">🇰🇪 Kenya Leads</span>
              </div>
              <a
                href="https://worldquantumday.org/quantum-city-prize"
                target="_blank"
                rel="noopener noreferrer"
                className="camps-btn camps-btn--teal"
              >
                About Quantum City Prize <ArrowRightIcon />
              </a>
            </div>

            {/* Right: IYQ logos (World Quantum Day + Quantum City) */}
            <div className="camps-col-media">
              <div className="camps-qcity-logos-display">
                <div className="camps-qcity-logos-inner">
                  <div className="camps-qcity-logo-wrap">
                    <img src={IYQ2} alt="Quantum City" className="camps-qcity-logo-img" />
                    <span className="camps-qcity-logo-label">Quantum City</span>
                  </div>
                  <div className="camps-qcity-logo-vdivider" />
                  <div className="camps-qcity-logo-wrap">
                    <img src={IYQ1} alt="World Quantum Day" className="camps-qcity-logo-img" />
                    <span className="camps-qcity-logo-label">World Quantum Day</span>
                  </div>
                </div>
                <div className="camps-qcity-logos-tag">IYQ 2025 · UNESCO Initiative</div>
              </div>
            </div>
          </div>

          {/* Activities grid */}
          <div className="camps-city-activities">
            {cityActivities.map((act, i) => (
              <div key={i} className="camps-city-activity-card">
                <div className="camps-city-act-icon">{act.icon}</div>
                <h3 className="camps-city-act-title">{act.title}</h3>
                <p className="camps-city-act-desc">{act.desc}</p>
              </div>
            ))}
          </div>

          {/* AQS callout */}
          <div className="camps-aqs-callout">
            <div className="camps-aqs-callout-img-wrap">
              <img src={hubsBanner} alt="Africa Quantum Summit Nairobi" className="camps-aqs-callout-img" />
              <div className="camps-aqs-callout-overlay" />
            </div>
            <div className="camps-aqs-callout-text">
              <div className="camps-aqs-callout-badge">Historic Milestone</div>
              <h3 className="camps-aqs-callout-title">Africa Quantum Summit · Nairobi 2025</h3>
              <p className="camps-aqs-callout-desc">
                Nairobi, Kenya | October 23–24 & December 2025<br />
                <em>"Empowering Africa's Quantum Future: Innovation, Collaboration, and Inclusion"</em>
              </p>
              <div className="camps-aqs-stats">
                <div className="camps-aqs-stat">
                  <span className="camps-aqs-stat-num">Top 10</span>
                  <span className="camps-aqs-stat-lbl">Kenya's African Quantum Ranking</span>
                </div>
                <div className="camps-aqs-stat">
                  <span className="camps-aqs-stat-num">2×</span>
                  <span className="camps-aqs-stat-lbl">Summits Hosted in 2025</span>
                </div>
              </div>
            </div>
          </div>

          {/* Reports — AQS Report + Quantum Horizon */}
          <div className="camps-reports-grid">
            <div className="camps-report-card camps-report-card--aqs"
              style={{ backgroundImage: `linear-gradient(135deg, rgba(6,182,212,0.35) 0%, rgba(59,130,246,0.35) 100%), url(${aqsReportCover})` }}>
              <div className="camps-report-card-overlay" />
              <div className="camps-report-card-content">
                <div className="camps-report-icon camps-report-icon--aqs"><BookIcon /></div>
                <h3 className="camps-report-title">AQS Report</h3>
                <p className="camps-report-subtitle">Africa Quantum Summit 2025</p>
                <a
                  href="/assets/aqs-report-2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  download="aqs-report-2025.pdf"
                  className="camps-report-btn camps-report-btn--aqs"
                >
                  <DownloadIcon /> Download Report
                </a>
              </div>
            </div>

            <div className="camps-report-card"
              style={{ backgroundImage: `linear-gradient(135deg, rgba(59,246,137,0.3) 0%, rgba(147,51,234,0.3) 100%), url(${whitePaperCover})` }}>
              <div className="camps-report-card-overlay" />
              <div className="camps-report-card-content">
                <div className="camps-report-icon"><BookIcon /></div>
                <h3 className="camps-report-title">Quantum Horizon</h3>
                <p className="camps-report-subtitle">Africa Quantum White Paper 2025</p>
                <a
                  href="https://africaquantum.org/whitepaper.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="camps-report-btn"
                >
                  View White Paper <ExternalLinkIcon />
                </a>
              </div>
            </div>
          </div>

          {/* Supported By */}
          <div className="camps-partners-section">
            <h3 className="camps-partners-title">Supported By</h3>
            <div className="camps-partners-track">
              <div className="camps-partners-scroll">
                {partners.map((p, i) => (
                  <div key={i} className="camps-partner-item">
                    <img src={p.logo} alt={p.name} />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prize context */}
          <div className="camps-prize-context">
            <h3 className="camps-prize-title">The Global Quantum City Prize 2025</h3>
            <p className="camps-prize-desc">
              Cities worldwide competed by bringing quantum science into public spaces.
              Africa's continental prize was awarded to Alamein City, Egypt, for interactive quantum stations
              reaching 750+ visitors. Nairobi is building toward future recognition.
            </p>
            <div className="camps-prize-grid">
              {[
                { continent: "Europe", city: "Putignano, Italy", project: "Quantum paradoxes in papier-mâché sculptures in a medieval city center" },
                { continent: "Africa", city: "Alamein City, Egypt", project: "Interactive quantum stations & educational games in public spaces" },
                { continent: "Asia", city: "Osaka, Japan", project: "Quantum posters to 1,700+ schools; 800,000 students reached" },
                { continent: "Americas", city: "Urbana-Champaign, USA", project: "Public Quantum Network (PQN) installations" },
              ].map((w, i) => (
                <div key={i} className="camps-prize-card">
                  <div className="camps-prize-continent">{w.continent}</div>
                  <div className="camps-prize-city">{w.city}</div>
                  <p className="camps-prize-project">{w.project}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>}

    </div>
  )
}

export default CampaignsPage
